import React, { useState } from 'react'
import './styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faEye, faVideo } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

export default function SummaryAulas({item, setSelectedAula}) {

    
    const [isOpen, setIsOpen] = useState(false);

    const toggleSummary = () => {
        setIsOpen(isOpen);
    };

    return (
        <div style={{ margin: '20px 0' }}>
            <details open={isOpen}>
                <summary onClick={toggleSummary}><h3>{item.titulo}</h3> <FontAwesomeIcon color='#3E64DE' icon={faAngleRight} size='1x' /></summary>
                {
                item.aulas.map(aula=>{
                    return(
                        <Card setSelectedAula={setSelectedAula} icon={faVideo} aula={aula} icon2={faEye} title={aula.titulo} time={aula.duracao} complete={aula.assistido} />
                    )
                })
            }
            </details>
        </div>
    )
}
 

function Card({ title, icon, icon2, time, setSelectedAula, aula }) {

    const navigate = useNavigate();

    return (
        <div /* onClick={()=>{
            setSelectedAula(aula)
            navigate(`/aula`)
            }} */ className='cardSummary' style={{ cursor: 'auto', padding: '0 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '40px'}}>
            <div style={{display: 'flex'}}>
                <FontAwesomeIcon icon={icon} color='#717171' style={{alignSelf: 'center', marginRight: '10px'}} />
                <h3 style={{color: '#717171'}}>{title}</h3>

            </div>
            <div style={{display: 'flex'}}>
                <h3 style={{color: '#717171'}}>{time}</h3>
                <FontAwesomeIcon icon={icon2} color='#717171' style={{alignSelf: 'center', marginLeft: '10px'}} />
            </div>
        </div>
    )
}

